import Vue from 'vue'
import Router from 'vue-router'
import common from '@/utils/common.js'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const vueRouter = new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: () => import("@/views/home/Home.vue"),
            redirect: "/newhome",
            children: [
                {
                    path: "search",
                    component: {render: (createEle) => createEle("router-view")},
                    children: [
                        {path: "/", name: "Search", component: () => import("@/views/search/search.vue")},
                        {path: "list", name: "List", component: () => import("@/views/search/list/list.vue")},
                        {path: "detail", name: "Detail", component: () => import("@/views/search/detail/detail.vue")},
                    ],
                },
                {
                    path: "submit",
                    component: {render: (createEle) => createEle("router-view")},
                    children: [
                        {path: "/", name: "Submit", component: () => import("@/views/submit/submit.vue")},
                        {path: "detail", name: "Detail", component: () => import("@/views/search/detail/detail.vue")},
                    ],
                },
                {
                    path: "update",
                    component: {render: (createEle) => createEle("router-view")},
                    children: [
                        {path: "/", name: "Update", component: () => import("@/views/update/update.vue")},
                        {path: "detail", name: "Detail", component: () => import("@/views/search/detail/detail.vue")},
                    ],
                },
                {
                    path: "newhome",
                    component: {render: (createEle) => createEle("router-view")},
                    children: [
                        {path: "/", name: "NewHome", component: () => import("@/views/home/NewHome.vue"),
                        children:[
                            // {path: "/", name: "NewHome", component: () => import("@/views/home/charTest.vue")},
                            // {path: "charTest", name: "charTest", component: () => import("@/views/home/charTest.vue")},
                            // {path: "charTest2", name: "charTest2", component: () => import("@/views/home/charTest2.vue")},
                            // {path: "charTest3", name: "charTest3", component: () => import("@/views/home/charTest3.vue")},
                            // {path: "charTest4", name: "charTest4", component: () => import("@/views/home/charTest4.vue")}
                        ]
                        },
                    ],
                },
            ]
        },
        {
            path: "/login",
            component: {render: (createEle) => createEle("router-view")},
            children: [
                {path: "/", name: "Login", component: () => import("@/views/login/login.vue")},
            ],
        },
        {
            path: "/charTest",
            component: {render: (createEle) => createEle("router-view")},
            children: [
                {path: "/", name: "charTest", component: () => import("@/views/home/charTest.vue")},
            ],
        },
        {
            path: "/charTest2",
            component: {render: (createEle) => createEle("router-view")},
            children: [
                {path: "/", name: "charTest2", component: () => import("@/views/home/charTest2.vue")},
            ],
        },
        {
            path: "/charTest3",
            component: {render: (createEle) => createEle("router-view")},
            children: [
                {path: "/", name: "charTest3", component: () => import("@/views/home/charTest3.vue")},
            ],
        },
        {
            path: "/charTest4",
            component: {render: (createEle) => createEle("router-view")},
            children: [
                {path: "/", name: "charTest4", component: () => import("@/views/home/charTest4.vue")},
            ],
        },
        // {
        //     path: "/charTest5",
        //     component: {render: (createEle) => createEle("router-view")},
        //     children: [
        //         {path: "/", name: "charTest5", component: () => import("@/views/home/charTest5.vue")},
        //     ],
        // }

    ],
    //新增history模式
    // mode:'history'
})

// 全局路由前置守卫，防止没有权限的用户进入某些页面
vueRouter.beforeEach(function (to, from, next) {
    const nextRoute = ['/submit', '/update'];
    const auth = common.hasMasterPermission();
    const isIncludesNextRoute = nextRoute.some(item => to.path.includes(item))
    //跳转至上述3个页面
    if (isIncludesNextRoute) {
        if (auth) {
            next()
            return
        }
        vueRouter.push("/search")
        // next("/search")
    }
    next();
});

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js